import React, { useState, FormEvent } from 'react';
import Dialog from 'components/common/react-dialog';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Button } from 'components/common/Button';
import style from './StripeCheckout.scss';

interface CheckoutFormProps {
  supplierPaymentId: string;
}

export default function CheckoutForm({ supplierPaymentId }: CheckoutFormProps) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const url = new URL(window.location.href);
    url.searchParams.set('supplier_payment_id', String(supplierPaymentId));

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: url.toString(),
      },
    });

    if (error?.type === 'card_error' || error?.type === 'validation_error') {
      setMessage(error.message || 'An error occurred.');
    } else {
      setMessage('An unexpected error occurred.');
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: 'accordion' as const,
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog title="iDeal Payment" width={620} onClose={() => setIsOpen(false)}>
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" options={paymentElementOptions} />
        <Button
          disabled={isLoading || !stripe || !elements}
          dataTest="submit"
          label={isLoading ? 'Loading' : 'Pay now'}
          type="submit"
          variant="primary"
          colour="default"
        />
        {message && (
          <div id="payment-message" className={style.paymentMessage}>
            {message}
          </div>
        )}
      </form>
    </Dialog>
  );
}
